import { cva } from "class-variance-authority";

const stylesBg = cva(
  "invisible absolute top-[64px] group-hover:visible w-[300px] right-0 flex flex-col pt-[25px] pb-[10px] shadow-lg rounded-[8px]",
  {
    variants: {
      mode: {
        light: "bg-light-background",
        dark: "bg-dark-background"
      }
    }
  }
);

const stylesUid = cva("flex items-center text-[12px]", {
  variants: {
    mode: {
      light: "text-light-label-40",
      dark: "text-dark-label-40"
    }
  }
});

const stylesVip = cva(
  "bu-px-[4px] bu-py-[2px] h-[24px] flex items-center justify-center rounded-[2px] text-[14px]",
  {
    variants: {
      mode: {
        light: "bg-light-primary-14 text-light-primary",
        dark: "bg-dark-primary-14 text-dark-primary"
      }
    }
  }
);

const stylesBorder = cva("", {
  variants: {
    mode: {
      light: "border-light-line-primary",
      dark: "border-dark-line-primary"
    }
  }
});

const stylesMainAccount = cva("", {
  variants: {
    mode: {
      light: "text-light-label",
      dark: "text-dark-label"
    }
  }
});

const stylesSubAccount = cva("", {
  variants: {
    mode: {
      light: "text-light-label-40",
      dark: "text-dark-label-40"
    }
  }
});

const stylesCurrent = cva("px-[8px] py-[2px] rounded-[4px] text-[12px] leading-[18px]", {
  variants: {
    mode: {
      light: "bg-light-secondary-14 text-light-secondary",
      dark: "bg-dark-secondary-14 text-dark-secondary"
    }
  }
});

const stylesArrowIcon = cva("iconfont icon-search-fill text-[16px] ml-[10px] mr-[8px]", {
  variants: {
    mode: {
      light: "text-light-label-40",
      dark: "text-dark-label-40"
    }
  }
});

export {
  stylesBg,
  stylesUid,
  stylesVip,
  stylesBorder,
  stylesMainAccount,
  stylesSubAccount,
  stylesCurrent,
  stylesArrowIcon
};
